"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DescriptionItem = exports.DescriptionHeader = exports.DescriptionList = undefined;

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _Text = require("../Text");

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const DescriptionList = exports.DescriptionList = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "DescriptionList",
  componentId: "jyyee1-0"
})([""]);

DescriptionList.defaultProps = {
  borderRadius: 3,
  p: 3,
  border: "1px solid",
  borderColor: "palette.cloud.normalActive",
  lineHeight: "24px"
};

/** @component */
const DescriptionHeader = exports.DescriptionHeader = (0, _styledComponents2.default)(_Text2.default).withConfig({
  displayName: "DescriptionList__DescriptionHeader",
  componentId: "jyyee1-1"
})(["display:block;"]);

DescriptionHeader.defaultProps = {
  fontSize: 1,
  fontWeight: 1,
  color: "palette.ink.light"
};

/** @component */
const DescriptionItem = exports.DescriptionItem = (0, _styledComponents2.default)(_Text2.default).withConfig({
  displayName: "DescriptionList__DescriptionItem",
  componentId: "jyyee1-2"
})(["display:block;"]);

DescriptionItem.defaultProps = {
  fontSize: 1,
  fontWeight: 0,
  color: "palette.ink.normal"
};

/** @component */
exports.default = DescriptionList;